import _ from 'lodash'
import NextLink from 'next/link'
import { twMerge } from 'tailwind-merge'

const styleAlert = 'text-red-700 dark:text-orange-500'

export default function CardItem({ label, value, alert, url }: { label: any; value: any; alert?: boolean; url?: string }) {
  const Content = () => (
    <div className='flex justify-between gap-x-2 py-1.5 text-sm'>
      <dt className='font-light truncate'>{label}</dt>
      <dd
        className={twMerge('truncate', !_.isNumber(value) || value > 0 ? 'font-medium' : 'font-light', alert && styleAlert)}
        suppressHydrationWarning
      >
        {value}
      </dd>
    </div>
  )
  if (url && value) {
    return (
      <div className='hover:text-red-800 dark:hover:text-orange-500 hover:bg-zinc-100 dark:hover:bg-transparent'>
        <NextLink href={url}>
          <Content />
        </NextLink>
      </div>
    )
  }
  return <Content />
}
